/* unplugin-vue-components disabled */import { render } from "./comp4.vue?vue&type=template&id=10b653b6&scoped=true"
import script from "./comp4.vue?vue&type=script&lang=js"
export * from "./comp4.vue?vue&type=script&lang=js"

import "./comp4.vue?vue&type=style&index=0&id=10b653b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b653b6"]])

export default __exports__